
export default {
  props: {
    report: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      reportInfo: this.report[0], // 举报数据
      reportPop: false
    }
  },
  created() {},
  mounted() {},
  methods: {
    reportseal(item) {
      this.$emit('reportseal', item)
    },
    setreportPop() {
      this.reportInfo = this.report[0]
      this.reportPop = !this.reportPop
    }
  }
}
